import { Filter, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

/**
 * FilterChipBar — visualises the active filters coming from useSmartFilters.
 *
 * Props
 *  - chips: [{ key, label, onClear }] — pass only the filters that are currently active
 *  - onClearAll: () => void
 */
export default function FilterChipBar({ chips = [], onClearAll, className = "" }) {
  if (!chips.length) return null;
  return (
    <div className={`flex items-center flex-wrap gap-2 rounded-lg border bg-muted/20 px-3 py-2 ${className}`} data-testid="filter-chip-bar">
      <Filter className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
      {chips.map((c) => (
        <Badge
          key={c.key}
          variant="outline"
          className="rounded-md bg-background gap-1.5 pl-2 pr-1 py-1 font-medium"
          data-testid={`chip-${c.key}`}
        >
          <span>{c.label}</span>
          {c.onClear && (
            <button
              onClick={c.onClear}
              className="rounded hover:bg-muted p-0.5 transition-colors"
              aria-label="Clear filter"
              data-testid={`chip-clear-${c.key}`}
            >
              <X className="w-3 h-3" />
            </button>
          )}
        </Badge>
      ))}
      {onClearAll && chips.length > 1 && (
        <Button
          size="sm"
          variant="ghost"
          onClick={onClearAll}
          className="h-6 text-[11px] rounded-md ml-auto"
          data-testid="clear-all-filters"
        >
          Clear
        </Button>
      )}
    </div>
  );
}
